export const isExistingRowEditing = <
  T extends { actionId?: number; partId?: number },
>(
  row: T,
  editingRows: T[],
  idKey: 'actionId' | 'partId',
) => {
  const id = row[idKey];
  return !!id && editingRows.some((item) => item[idKey] === id);
};

export const withEditingRows = <
  T extends { actionId?: number; partId?: number },
>(
  rows: T[],
  editingRows: T[],
  idKey: 'actionId' | 'partId',
) => {
  if (!editingRows.length) return rows;
  return rows.map((row) => {
    const draft = editingRows.find(
      (item) => item[idKey] && item[idKey] === row[idKey],
    );
    return draft ?? row;
  });
};

export const upsertEditingRow = <
  T extends { actionId?: number; partId?: number },
>(
  editingRows: T[],
  row: T,
  idKey: 'actionId' | 'partId',
) => {
  if (editingRows.some((item) => item[idKey] === row[idKey])) {
    return editingRows;
  }
  return [...editingRows, { ...row }];
};

export const patchEditingRow = <T extends { id: number }>(
  editingRows: T[],
  id: number,
  patch: Partial<T>,
) => editingRows.map((row) => (row.id === id ? { ...row, ...patch } : row));

export const removeEditingRow = <
  T extends { actionId?: number; partId?: number },
>(
  editingRows: T[],
  id: number | undefined,
  idKey: 'actionId' | 'partId',
) => editingRows.filter((row) => row[idKey] !== id);
